module.exports = __webpack_public_path__ + "sgby/img/dongzhuo-pic.d82758a.png";